import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Route, Routes, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ErrorModal, SpinCentered, StationPage } from '@/comp';
import { useStores } from '@/hooks/use-stores';
import { NavigateWithParams } from '../StationPage/StationPage.utils';
import { ResponsiveProvider } from '@/hooks/useResponsive';

const HomePage = observer(() => {
  const { stationStore } = useStores();
  const { t } = useTranslation();
  const isReady = stationStore.isReady;
  const {
    userStore: { getUserMeRequestFailed, setGetUserMeRequestFailed },
  } = useStores();

  const resetUserError = () => {
    stationStore.resetStationStoreUserError();
    setGetUserMeRequestFailed(false);
  };

  const [searchParams] = useSearchParams();

  const renderStationPage = isReady ? <StationPage /> : <SpinCentered />;

  return (
    <Container>
      <ResponsiveProvider> 
        <Routes>
          <Route path="station/:stationId/*" element={renderStationPage} />
          <Route path="station/*" element={renderStationPage} />
    
          <Route path="/*" element={NavigateWithParams('station', true, searchParams)} />
        </Routes>
        <ErrorModal
          condition={getUserMeRequestFailed || stationStore.stationStoreUserError}
          resetCallback={resetUserError}
          errorText={t('Please try again later.')}
        />
      </ResponsiveProvider>
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  align-items: stretch;
  height: 100%;
`;

export default HomePage;
